// Какие данные карточки клиента компания требует настройками приложения
// (/cab/settings/new_mobile → «Имя клиента», «Email»). Правила те же, что в
// приложении (Onboarding.tsx) и на сервере (ClientRequiredFields).
//
// «Только имя» и «Email: собирать» — прежнее поведение сайта: ничего отдельно
// не требуем, достаточно ФИО заказа.

const EMAIL_RE = /^[^\s@]+@[^\s@]+$/;

function blank(v) {
  return !v || !String(v).trim();
}

// Что именно требуется у этой компании. middleOptional — «Фамилия и Имя»:
// поле отчества показываем, но не требуем (как в приложении)
export function requiredClientFields(company) {
  if (!company || !company.site_require_client_fields) {
    return { first: false, last: false, middle: false, middleOptional: false, email: false };
  }
  const rule = company.mobile_client_name_required || 'first_only';
  return {
    first: rule === 'first_and_last' || rule === 'all',
    last: rule === 'first_and_last' || rule === 'all',
    middle: rule === 'all',
    middleOptional: rule === 'first_and_last',
    email: company.mobile_client_email === 'collect_and_require',
  };
}

export function anyClientFieldRequired(company) {
  const r = requiredClientFields(company);
  return r.first || r.last || r.middle || r.email;
}

// values: { first, last, middle, email } → { first, last, middle, email: 'текст ошибки' }
export function clientFieldErrors(company, values) {
  const r = requiredClientFields(company);
  const e = {};
  if (r.first && blank(values.first)) e.first = 'Укажите имя';
  if (r.last && blank(values.last)) e.last = 'Укажите фамилию';
  if (r.middle && blank(values.middle)) e.middle = 'Укажите отчество';
  const email = (values.email || '').trim();
  if (r.email && !email) {
    e.email = 'Укажите ' + ((company.mobile_email_title || 'email').toLowerCase());
  } else if (r.email && !EMAIL_RE.test(email)) {
    e.email = 'Некорректный email';
  }
  return e;
}

// Значения из карточки клиента (client_info мобильного токена)
export function clientFieldValues(clientInfo) {
  const ci = clientInfo || {};
  return {
    first: ci.mobile_first_name || '',
    last: ci.mobile_last_name || '',
    middle: ci.mobile_middle_name || '',
    email: ci.email || '',
  };
}

// Порядок как на сервере (settings_params): Фамилия Имя Отчество
export function fioFromParts(values) {
  return [values.last, values.first, values.middle]
    .map((v) => (v || '').trim())
    .filter(Boolean)
    .join(' ');
}

// Патч для authStore.updateClientInfo: все три части — сервер собирает из них
// mobile_fio, и пропущенная часть пропала бы из имени.
export function clientInfoPatch(values) {
  return {
    mobile_first_name: (values.first || '').trim(),
    mobile_last_name: (values.last || '').trim(),
    mobile_middle_name: (values.middle || '').trim(),
    email: (values.email || '').trim(),
  };
}



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/shared/clientFields.js